// src/LoanProgram.js

import React, { useEffect } from 'react';
import { IMAGES } from '../assets/img/ImageIndex';
import { Link, useLocation } from 'react-router-dom';

function LoanProgram() {
  const location = useLocation();

  useEffect(() => {
    // Set document title and meta tags
    document.title = 'Working Capital & Business Loan Programs | EnvoCapital USA';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Explore EnvoCapital\'s working capital loans, business credit lines, equipment financing, and short-term business loans designed for modern small businesses across the USA.');
    }

    if (location.hash) {
      const element = document.getElementById(location.hash.slice(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.hash]);

  return (
    <div className="loan-program-page">
      <div className="page-banner-area bg-gray2">
        <div className="container mw-1380">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="page-banner-content">
                <ul className="ps-0 list-unstyled breadcrumbs">
                  <li><Link to="/">Home</Link></li>
                  <li>Loan Program</li>
                </ul>
                <h1>Empowering Your Business Growth: Your Journey to the Right Financing Starts Here</h1>
                <p>We are committed to securing the best financial solution for your business. From initial assessment to final approval, our goal is to deliver seamless service while helping you save time and money. We tailor every step to your unique needs and identify the most suitable loan program with the best possible terms.</p>
                {/* <Link to="/calculate-mortgage/" className="read-more text-primary">
                  Calculate Your Payments
                  <i className="fi fi-rs-arrow-right"></i>
                </Link> */}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="page-banner-img text-center text-lg-end position-relative z-1">
                <img src={IMAGES.bannerImg5} className="img" alt="banner-img"/>
                <img src={IMAGES.shape7} className="shape shape-7" alt="Shape1"/>
                <img src={IMAGES.shape8} className="shape shape-8" alt="Shape2"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="buying-area overflow-hidden ptb-130">
        <div className="container mw-1380">
          <div className="section-title mw-760">
            {/* <h2 className="title">Buying a home can be overwhelming. There are so many financing options</h2> */}
            <h2 className="title">Business growth needs capital. Here are your best financing options</h2>
          </div>
          <div className="row">
            {[
              {
                id: 1,
                image: IMAGES.buying6,
                scrollId: "Revenue-based-financing",
                title: "Revenue-based financing",
                description: "Revenue-based financing is a type of financing that allows you to finance your home based on your future income."
              },
              {
                id: 2,
                image: IMAGES.buying4,
                scrollId: "SBA",
                title: "SBA",
                description: "SBA loans are a type of government-backed loan that allows you to finance your home based on your future income."
              },
              {
                id: 3,
                image: IMAGES.buying5,
                scrollId: "Term-Loans",
                title: "Term Loans",
                description: "Term loans are a type of government-backed loan that allows you to finance your home based on your future income."
              },
              {
                id: 4,
                image: IMAGES.buying3,
                scrollId: "Line-of-Credit",
                title: "Line of Credit",
                description: "Line of Credit is a type of government-backed loan that allows you to finance your home based on your future income."
              },
            ].map((item) => (
              <div id={item.scrollId} key={item.id} className="d-flex col-lg-3 col-md-6">
                <div className="buying-single-item mb-4 transition-y">
                  <Link to={`/loan-program#${item.scrollId}`} className="d-block buying-img">
                    <img 
                      src={item.image} 
                      alt={item.title}
                      className="img-fluid"
                    />
                  </Link>
                  <div className="buying-content">
                    <h3>
                      <Link to="/loan-program">
                        {item.title}
                      </Link>
                    </h3>
                    <p>{item.description}</p>
                    {/* <div className="border-top">
                      <Link to="/loan-program" className="read-more">
                        Learn More
                        <i className="fi fi-rs-arrow-right"></i>
                      </Link>
                    </div> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoanProgram;
